import { render, staticRenderFns } from "./SaveWarning.vue?vue&type=template&id=ff7d3db4&scoped=true&"
import script from "./SaveWarning.vue?vue&type=script&lang=js&"
export * from "./SaveWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7d3db4",
  null
  
)

export default component.exports